import { Button } from "@faire/slate/components/button";
import { Tab } from "@faire/slate/components/tab";
import { TabGroup } from "@faire/slate/components/tab";
import { Tag } from "@faire/slate/components/tag";
import { Settings } from "@faire/slate-icons/Settings";
import { useState } from "react";

import { BreakevenRoasDrawer } from "./BreakevenRoasDrawer";
import { PerformanceOverviewCard } from "./PerformanceOverviewCard";
import { ADS_MANAGER_TABS } from "./productionAssets";

/**
 * Post-adoption Promoted Listings overview page.
 * Shell + tabs match production Ads Manager; overview body uses the production
 * screenshot so metrics, chart, and tables stay pixel-accurate.
 */
export const AdsManagerOverviewPage = () => {
  const [selectedTab, setSelectedTab] = useState("overview");
  const [isBreakevenDrawerOpen, setIsBreakevenDrawerOpen] = useState(false);

  return (
    <div className="bg-fs-surface-primary flex min-h-screen min-w-0 flex-1 flex-col">
      <header
        className="bg-fs-surface-primary px-6 pt-6"
        data-test-id="ads-manager-header"
      >
        <div className="mx-auto flex max-w-[1580px] flex-col gap-1">
          <div className="flex items-start gap-8">
            <div className="flex-1 pt-[5px]">
              <h1 className="type-fs-display-m text-fs-text-primary">
                Promoted Listings
              </h1>
            </div>
            <div className="flex h-12 items-center">
              <Button
                variant="secondary"
                size="small"
                iconProps={{ Component: Settings, position: "end" }}
              >
                Advertising settings
              </Button>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <Tag label="Active" variant="success" />
            <span className="type-fs-paragraph text-fs-text-subdued">
              Renews Jul 1, 2026 with a monthly budget of $6,000
            </span>
          </div>
        </div>
      </header>

      <div className="bg-fs-surface-primary border-fs-border-muted border-b">
        <div className="mx-auto max-w-[1580px] px-6">
          <div className="-mx-10 px-4">
            <TabGroup selectedTabValue={selectedTab} onSelect={setSelectedTab}>
              {ADS_MANAGER_TABS.map((tab) => (
                <Tab
                  key={tab.value}
                  value={tab.value}
                  label={tab.label}
                  selected={selectedTab === tab.value}
                />
              ))}
            </TabGroup>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[1580px] flex-1 px-10 pt-6 pb-20">
        {selectedTab === "overview" ? (
          <PerformanceOverviewCard
            onOpenBreakevenDrawer={() => setIsBreakevenDrawerOpen(true)}
          />
        ) : (
          <div className="border-fs-border-muted bg-fs-surface-secondary type-fs-paragraph text-fs-text-subdued rounded-lg border p-8 text-center">
            {ADS_MANAGER_TABS.find((tab) => tab.value === selectedTab)?.label}{" "}
            tab is out of scope for this prototype. The Overview tab mirrors
            production Ads Manager today.
          </div>
        )}
      </div>

      <BreakevenRoasDrawer
        isOpen={isBreakevenDrawerOpen}
        onClose={() => setIsBreakevenDrawerOpen(false)}
      />
    </div>
  );
};
